import React, { useContext } from "react";
import { LogBookSelectContext } from "./logBooksSelectAll/context";
import { Checkbox } from "@mui/material";

const SubInstrumentsSelect = React.memo(({ visibility, item, disabled, ...rest }) => {
  const { isSelected, onSelect } = useContext(LogBookSelectContext);
  if (!visibility) return null;
  return (
    <Checkbox
      data-testid={`devices-item-checkbox-${item?.inventoryId}`}
      edge="start"
      tabIndex={-1}
      disableRipple
      color="primary"
      style={{ width: 20, height: 20 }}
      checked={isSelected({ ...item })}
      onChange={(event) => {
        onSelect({ ...item });
        event.stopPropagation();
      }}
      onClick={(event) => event.stopPropagation()}
      disabled={disabled}
      {...rest}
    />
  );
});

export default SubInstrumentsSelect;
